import * as types from '../../../constants/ActionTypes';
import service from '../../../service';

export const setSearchedAddress = searchedAddress => ({
    type: types.SET_PROPERTY_ADDRESS,
    searchedAddress,
});

export const doSearch = params => ({
    type: types.SET_PROPERTY_SEARCH,
    payload: new Promise((resolve, reject) => {
        // TODO: unmock
        service.api({
            method: 'propertiesList',
            params,
        })
            .then((data) => {
                // if (data.error) {
                //     reject(data.error);
                // }
                // TODO: unmock
                const propertyList = [
                    {
                        propertyId: 'string1',
                        address: {
                            city: 'City',
                            postalCode: 'LH 12HH',
                            street: 'street',
                            houseNumber: '12',
                        },
                        photo: 'https://i.ytimg.com/vi/Xx6t0gmQ_Tw/maxresdefault.jpg',
                        value: {
                            estaminatedPropertyValue: {
                                amount: 12330,
                                currency: 'gbp',
                            },
                            estaminatedPropertyMonthlyRent: {
                                amount: 1220,
                                currency: 'gbp',
                            },
                        },
                        lastSale: {
                            amount: 0,
                            currency: 'gbp',
                        },
                    },
                    {
                        propertyId: 'string2',
                        address: {
                            city: 'City',
                            postalCode: 'LH 12HH',
                            street: 'street street',
                            houseNumber: '14',
                        },
                        photo: 'https://i.ytimg.com/vi/Xx6t0gmQ_Tw/maxresdefault.jpg',
                        value: {
                            estaminatedPropertyValue: {
                                amount: 22330,
                                currency: 'gbp',
                            },
                            estaminatedPropertyMonthlyRent: {
                                amount: 230,
                                currency: 'gbp',
                            },
                        },
                        lastSale: {
                            amount: 0,
                            currency: 'gbp',
                        },
                    },
                ];
                resolve(propertyList);
            })
            .catch((error) => {
                reject(error);
            });
    }),
});

export const selectProperty = property => ({
    type: types.SET_SELECTED_PROPERTY,
    property,
});



// WEBPACK FOOTER //
// ./src/app/FormStepper/PropertyDetails/propertyDetailsActions.js